// Generated by Claude Code
import { Type } from 'class-transformer'
import { BaseIdModel } from '#core/entities/shared/BaseModels.ts'
import type { CompanyAccessRequestStatus } from './CompanyAccessRequest.ts'

/** One of the signed-in user's own access requests, as listed by `GET /auth/company-access-requests/mine`. */
export default class OwnCompanyAccessRequest extends BaseIdModel {
  company_id: string = ''
  company_name: string = ''
  status: CompanyAccessRequestStatus = 'PENDING'
  @Type(() => Date)
  created_at: Date | null = null
  @Type(() => Date)
  decided_at: Date | null = null
}
